import { Link } from 'react-router-dom';

import MicrosoftOverview from '../components/cloudPrep/microSoft/MicrosoftOverview';

const MicrosoftOverviewPage = () => {
  return (
    <MicrosoftOverview
      isAIOverview={false}
      title='Azure Fundamentals'
      description='Demonstrate foundational knowledge of cloud concepts, core Azure services, plus Azure management and governance features and tools.'
      lastUpdated='10/30/2025'
      role='Administrator'
      linkTo='https://learn.microsoft.com/en-us/credentials/certifications/azure-fundamentals/?practice-assessment-type=certification'
    >
      <div className='space-y-6 text-gray-700'>
        <p className='text-base leading-relaxed'>
          As a candidate for this certification, you&apos;re a technology
          professional who wants to demonstrate foundational knowledge of cloud
          concepts in general and Microsoft Azure in particular. This
          certification is a common starting point in a journey towards a career
          in Azure.
        </p>

        <p className='text-base leading-relaxed'>
          You can describe Azure architectural components and Azure services,
          such as:
        </p>

        <ul className='ml-4 list-inside list-disc space-y-2'>
          <li>Compute</li>
          <li>Networking</li>
          <li>Storage</li>
        </ul>

        <p className='text-base leading-relaxed'>
          You can also describe features and tools to secure, govern, and
          administer Azure.
        </p>

        <p className='text-base leading-relaxed'>
          You should have skills and experience working with an area of IT, such
          as:
        </p>

        <ul className='ml-4 list-inside list-disc space-y-2'>
          <li>Infrastructure management</li>
          <li>Database management</li>
          <li>Software development</li>
        </ul>

        <p className='text-base leading-relaxed'>
          You may be eligible for ACE college credit if you pass this
          certification exam. See{' '}
          <Link
            target='_blank'
            to='https://learn.microsoft.com/en-us/credentials/certifications/college-credit'
            className='text-blue-600 hover:text-blue-800 hover:underline'
          >
            ACE college credit for certification exams
          </Link>{' '}
          for details.
        </p>
      </div>
    </MicrosoftOverview>
  );
};

export default MicrosoftOverviewPage;
